import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

const useAuth = () => {
    const context = useContext(AuthContext);
    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASE_API_URL;

    const logout = async () => {
        try {
            const token = localStorage.getItem("token");
            // Gọi API để server clear httpOnly cookie
            await axios.post(
                `${baseUrl}/api/auth/manage-employee/logout-employee`,
                {},
                { 
                    withCredentials: true,
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
        } catch (error) {
            console.error("Logout API error:", error);
        } finally {
            // Luôn clear localStorage và redirect dù API thành công hay thất bại
            localStorage.clear();
            context.dispatch({ type: "LOGOUT" });
            navigate("/login");
        }
    };

    return {
        user: context.user,
        userId: context.user?.id,
        userName: context.user?.name,
        department: context.user?.department,
        role: context.user?.role,
        isLoggedIn: !!context.user,
        loading: context.loading,
        error: context.error,
        dispatch: context.dispatch,
        logout,
    };
};

export default useAuth;
